import React from "react";
import { Row, Col, Card, Typography, Divider, Progress, Tooltip } from "antd";
import Chart from "react-apexcharts";
import { formatIndian } from "../../../Utils/utils";
import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

export default function EnquiryCard({
  marketData,
  factoryData,
  label = "Enquiry",
  data2 = {},
}) {
  const values2 = [Number(data2.MTD_Value || 0), Number(data2.YTD_Value || 0)];
  const barData = [
    { type: "MTD", value: values2[0] },
    { type: "YTD", value: values2[1] },
  ];
  const maxBarValue = Math.max(...values2, 1);

  const colors = {
    primary: "#1890ff",
    primaryDark: "#0050b3",
    secondary: "#52c41a",
    secondaryDark: "#237804",
    text: "#333",
    background: "#ffffff",
  };

  const cardStyle = {
    borderRadius: 12,
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.06)",
    background: "linear-gradient(135deg, #fdfdfd 0%, #ffffff 100%)",
    transition: "all 0.3s ease-in-out",
    height: "100%",
  };

  const renderBarChart = () =>
    barData.map((item, index) => (
      <div key={index} style={{ marginBottom: 16 }}>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
          <Text
            strong
            style={{
              width: 40,
              color: colors.primaryDark,
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            {item.type}
          </Text>
          <Tooltip
            title={
              <div>
                <strong>{item.type}</strong>
                <div>Value: {formatIndian(item.value)}</div>
                <div>
                  {((item.value / maxBarValue) * 100).toFixed(1)}% of max
                </div>
              </div>
            }
          >
            <div style={{ flex: 1 }}>
              <Progress
                percent={(item.value / maxBarValue) * 100}
                strokeColor={colors.primary}
                trailColor="#f0f2f5"
                strokeWidth={8}
                showInfo={false}
                style={{ borderRadius: 6 }}
              />
            </div>
          </Tooltip>
          <Text
            style={{
              marginLeft: 10,
              fontWeight: 600,
              color: colors.primaryDark,
              fontSize: 13,
            }}
          >
            {formatIndian(item.value)}
          </Text>
        </div>
      </div>
    ));

  const commonChartConfig = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      animations: { enabled: true, easing: "easeinout", speed: 600 },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 6,
        columnWidth: "55%",
      },
    },
    dataLabels: {
      enabled: true,
      style: { colors: ["#fff"], fontWeight: 700, fontSize: "12px" },
      formatter: formatIndian,
    },
    xaxis: {
      labels: {
        style: { colors: "#595959", fontWeight: 600 },
      },
    },
    yaxis: {
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    grid: { show: false },
    tooltip: {
      y: { formatter: formatIndian },
    },
    legend: { show: false },
  };

  const marketOptions = {
    ...commonChartConfig,
    colors: [colors.primary, "#69c0ff", "#bae7ff"],
    xaxis: {
      ...commonChartConfig.xaxis,
      categories: marketData?.map((i) => i.Status || "Unknown"),
    },
  };

  const factoryOptions = {
    ...commonChartConfig,
    colors: [colors.secondary, "#95de64", "#d9f7be"],
    xaxis: {
      ...commonChartConfig.xaxis,
      categories: factoryData?.map((i) => i.Status || "Unknown"),
    },
  };

  const titleStyle = { fontWeight: 600, marginBottom: 12 };
  return (
    <Card style={cardStyle} bodyStyle={{ padding: 20 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Title level={5} style={{ ...titleStyle, color: "#c62828" }}>
          Total {label}
        </Title>
        <Link to="/crm/enquiry">
          <EyeOutlined style={{ fontSize: '16px', cursor: "pointer" }} />
        </Link>
      </div>
      {renderBarChart()}

      <Divider style={{ margin: "24px 0" }} />

      <Row gutter={[24, 24]}>
        <Col xs={24} md={12}>
          <Card style={cardStyle} bodyStyle={{ padding: 20 }}>
            <Text
              style={{
                color: colors.primaryDark,
                fontSize: 16,
                fontWeight: 600,
                marginBottom: 16,
                display: "block",
              }}
            >
              Marketing
            </Text>
            <Chart
              options={marketOptions}
              series={[{ name: "Market", data: marketData?.map((i) => i.Count || 0) }]}
              type="bar"
              height={280}
            />
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card style={cardStyle} bodyStyle={{ padding: 20 }}>
            <Text
              style={{
                color: colors.secondaryDark,
                fontSize: 16,
                fontWeight: 600,
                marginBottom: 16,
                display: "block",
              }}
            >
              Factory
            </Text>
            <Chart
              options={factoryOptions}
              series={[{ name: "Factory", data: factoryData?.map((i) => i.Count || 0) }]}
              type="bar"
              height={280}
            />
          </Card>
        </Col>
      </Row>
    </Card>
  );
}